import { render, staticRenderFns } from "./OutOfPolicyTag.vue?vue&type=template&id=1a5f7fd3&scoped=true&"
import script from "./OutOfPolicyTag.vue?vue&type=script&lang=js&"
export * from "./OutOfPolicyTag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a5f7fd3",
  null
  
)

export default component.exports